import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type JSX, useCallback, useEffect } from 'react'
import { z } from 'zod'
import { AppLoader } from '~/components/loader'
import { setSessionToken } from '~/features/auth'
import { PublicTemplate } from '~/templates/public'

import { Button, Heading1 } from '@hap/components'

export const Route = createFileRoute('/_public/auth/callback')({
  component: AuthCallback,
  validateSearch: z
    .object({ token: z.string() })
    .or(z.object({ signupToken: z.string() }))
    .or(z.object({ error: z.string() })),
})

export function AuthCallback(): JSX.Element {
  const search = Route.useSearch()
  const navigate = useNavigate()
  const validateToken = useCallback(async (token: string) => {
    setSessionToken(token)
    navigate({ to: '/', replace: true })
  }, [])

  useEffect(() => {
    if ('error' in search) {
      console.error('Authentication error:', search.error)
    } else if ('signupToken' in search) {
      navigate({
        to: '/signup/organization',
        search: { token: search.signupToken },
        replace: true,
      })
    } else {
      validateToken(search.token)
    }
  }, [search])
  return 'error' in search ? (
    <PublicTemplate>
      <div className="bg-accent text-center">
        <div className="flex flex-col content-center space-y-6 p-8">
          <Heading1>Authentication failed</Heading1>
          <p className="select-auto">
            If this issue persists, please reach out to us at{' '}
            <a className="text-hot-pink font-medium" href="mailto:support@happitu.com">
              support@happitu.com
            </a>
          </p>
          <Button onClick={() => navigate({ to: '/' })} size="lg">
            Try again
          </Button>
        </div>
      </div>{' '}
    </PublicTemplate>
  ) : (
    <PublicTemplate>
      <AppLoader />
    </PublicTemplate>
  )
}
